import { useQuery } from "@tanstack/react-query"
import { api } from "../lib/api/client"

/**
 * Hook to fetch all divisions the user has access to.
 * Divisions rarely change, so we use a long stale time.
 */
export function useDivisions() {
  return useQuery({
    queryKey: ["divisions"],
    queryFn: async () => {
      const result = await api.divisions.find()
      return result.data || []
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  })
}
